export const classConstants = {
  MAPC: "more-actions-popup-container",
  MAC: "more-actions-container",
};
